/* =====================================================================
   YFLA KIT (yk-) core, v66. Registry + boot + shared helpers.
   Elements:  <div class="yk yk-<name>" data-yk="<name>" data-yk-opts='{"k":"v"}'>
              YK.reg('<name>', function (el, opts) { ... })
   Enhancers: <div data-yk-enhance="chapters faq gallery steps tables frames">
              (page copy container)  YK.enh('<name>', function (container, opts) { ... })
   Every element must render complete, readable HTML without JS (crawlers,
   no-JS), and JS only adds behaviour. Never remove or rewrite page text.
   ===================================================================== */
(function () {
  'use strict';
  if (window.YK && window.YK.__core) return;
  var regs = {}, enhs = {}, done = typeof WeakSet === 'function' ? new WeakSet() : null;
  var YK = window.YK = window.YK || {};
  YK.__core = true;
  YK.version = 'v66';

  YK.qs = function (s, r) { return (r || document).querySelector(s); };
  YK.qsa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  YK.reduced = function () { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); };
  YK.opts = function (el) { try { return JSON.parse(el.getAttribute('data-yk-opts') || '{}'); } catch (e) { return {}; } };
  YK.money = function (n) { n = Math.round(Number(n) || 0); return '$' + n.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
  YK.clamp = function (n, a, b) { return Math.max(a, Math.min(b, n)); };
  YK.uid = (function () { var i = 0; return function (p) { i += 1; return (p || 'yk') + '-' + i; }; })();
  YK.track = function (action, label) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: 'yk_' + action, yk_label: label || '', yk_path: location.pathname });
    } catch (e) { /* no-op */ }
  };
  /* Range inputs: paint the filled part of the track (core.css reads --yk-fill). */
  YK.fill = function (input) {
    var min = +input.min || 0, max = +input.max || 100, v = +input.value;
    input.style.setProperty('--yk-fill', ((v - min) / (max - min || 1)) * 100 + '%');
  };

  /* Page scroller (QA-V66 fix). Horizon's base.css makes .page-wrapper the scroll container at
     >= 990px (html/body overflow:hidden, window.scrollY stays 0); below that the document scrolls.
     Kit code uses these instead of window.scrollY / window.scrollTo / window 'scroll' listeners. */
  YK.scroller = function () {
    var pw = document.querySelector('.page-wrapper');
    if (pw && pw.scrollHeight > pw.clientHeight + 1 && /(auto|scroll)/.test(getComputedStyle(pw).overflowY)) return pw;
    return null;
  };
  YK.scrollY = function () {
    var s = YK.scroller();
    return s ? s.scrollTop : (window.pageYOffset || document.documentElement.scrollTop || 0);
  };
  YK.scrollTo = function (top, behavior) {
    var s = YK.scroller(), o = { top: Math.max(0, Math.round(top)), behavior: behavior || 'auto' };
    if (s) s.scrollTo(o); else window.scrollTo(o);
  };
  /* fn(e) on PAGE scroll only (the document or .page-wrapper), not on inner scrollers (tables, strips) */
  YK.onScroll = function (fn) {
    window.addEventListener('scroll', function (e) {
      var t = e.target;
      if (t === document || t === window || t === document.documentElement || t === document.body ||
          (t && t.classList && t.classList.contains('page-wrapper'))) fn(e);
    }, { passive: true, capture: true });
  };

  YK.reg = function (name, fn) { regs[name] = fn; if (YK.__booted) YK.boot(document); };
  YK.enh = function (name, fn) { enhs[name] = fn; if (YK.__booted) YK.boot(document); };

  function once(el, key) {
    var k = '__yk_' + key;
    if (el[k]) return false;
    el[k] = true; return true;
  }

  YK.boot = function (root) {
    root = root || document;
    YK.qsa('[data-yk]', root).forEach(function (el) {
      var name = el.getAttribute('data-yk'), fn = regs[name];
      if (!fn || !once(el, name)) return;
      try { fn(el, YK.opts(el)); el.classList.add('yk-ready'); }
      catch (e) { if (window.console) console.warn('[yk] ' + name, e); }
    });
    YK.qsa('[data-yk-enhance]', root).forEach(function (box) {
      (box.getAttribute('data-yk-enhance') || '').split(/[\s,]+/).forEach(function (name) {
        var fn = enhs[name];
        if (!name || !fn || !once(box, 'enh_' + name)) return;
        try { fn(box, YK.opts(box)); }
        catch (e) { if (window.console) console.warn('[yk enhance] ' + name, e); }
      });
    });
  };

  /* Header offset: sticky kit parts sit UNDER the site header, never behind it
     (owner rule: nothing slides under the menu). Measures the tallest fixed or
     sticky element touching the top of the viewport inside #header-group. */
  var heads = null, paints = null;
  function alpha(bg) {
    if (!bg || bg === 'transparent') return 0;
    var m = bg.match(/rgba?\(([^)]+)\)/);
    if (!m) return 1;
    var p = m[1].split(/[\s,\/]+/).filter(Boolean);
    return p.length > 3 ? parseFloat(p[3]) : 1;
  }
  function headCands() {
    var all = YK.qsa('#header-group, #header-group *').filter(function (n) { return n.children.length <= 40; });
    heads = all.filter(function (n) {
      var p = getComputedStyle(n).position;
      return p === 'fixed' || p === 'sticky';
    });
    /* painted parts of the header (bars with a background): the sticky box (#header-group) has transparent
       padding under the visible bar, and the theme's own sticky navs sit at the bar's bottom edge */
    paints = all.filter(function (n) {
      var cs = getComputedStyle(n);
      return alpha(cs.backgroundColor) > 0.05 || cs.backgroundImage !== 'none';
    });
  }
  YK.headH = function () {
    if (!heads) headCands();
    var box = 0, h = 0;
    heads.forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (r.top <= 1 && r.bottom > box && r.height > 0 && r.height < 220) {
        var cs = getComputedStyle(n);
        if (cs.visibility !== 'hidden' && cs.display !== 'none') box = r.bottom;
      }
    });
    if (!box) return 0;
    paints.forEach(function (n) {
      var r = n.getBoundingClientRect();
      if (r.height <= 0 || r.height > 140 || r.width < 120 || r.bottom <= 0 || r.top >= box || r.bottom <= h) return;
      var cs = getComputedStyle(n);
      if (cs.visibility === 'hidden' || cs.display === 'none' || +cs.opacity === 0) return;
      h = r.bottom;
    });
    return Math.round(Math.min(box, h || box));
  };
  var lastHead = -1;
  function setHead() {
    var h = YK.headH() || 0;
    if (h === lastHead) return;
    lastHead = h;
    document.documentElement.style.setProperty('--yk-head', h + 'px');
  }
  YK.setHead = setHead;

  function start() {
    YK.__booted = true;
    setHead();
    YK.boot(document);
    var t, raf = 0;
    window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(function () { headCands(); setHead(); }, 150); }, { passive: true });
    /* every frame while the page scrolls: the header is sticky at top:-36px, so its bottom edge moves
       during the first screen; sticky kit parts (top: var(--yk-head)) follow it with no gap and no overlap */
    YK.onScroll(function () { if (!raf) raf = requestAnimationFrame(function () { raf = 0; setHead(); }); });
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('.yk a[href], .yk button[data-yk-track]');
      if (!a) return;
      YK.track('click', a.getAttribute('data-yk-track') || (a.textContent || '').trim().slice(0, 60));
    }, true);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
